import {css} from 'lit'; export default css`.tos-list{margin-top:var(--goto-spacing-02);line-height:var(--goto-layout-02)}`;
    